import { Request } from '../requests/Request';
import { ISetOwnerParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';

export class SetCustomizedViewsOwnerRequest extends Request<ISetOwnerParams, IResult> {
  constructor(ids: string[], ownerId: string) {
    super('setCustomizedViewsOwner', {
      ids: ids,
      ownerId: ownerId
    });
  }
}